function prefixZero(num) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var str = num.toString();

  while (str.length < length) {
    str = "0".concat(str);
  }

  return str;
}

export var formatDate = function formatDate(date) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  return [year, month, day].map(prefixZero).join(separator);
};
export var formatTime = function formatTime(date) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ':';
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  return [hour, minute, second].map(prefixZero).join(separator);
};
export var formatTimestamp = function formatTimestamp(date) {
  var dateStr = formatDate(date);
  var timeStr = formatTime(date);
  var millisecondStr = prefixZero(date.getMilliseconds(), 3);
  return "".concat(dateStr, " ").concat(timeStr, ".").concat(millisecondStr);
};